import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "rounding", "fontType"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NumberRatingMixin } from '../../mixins/components/NumberRatingMixin';
import { IconStar } from '../Icon/index';
import Text from '../Text/Text';
import { FONT_TYPES } from '../../constants/FONT_TYPES';
import { roundToDecimalPlace } from '../../util/rounding';
export var StyledNumberRating = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledNumberRating",
  componentId: "c11n-8-64-0__sc-1da2ent-0"
})(["", ""], NumberRatingMixin);
/**
 * The Number Rating component summarizes a collection of rating scores using
 * a form factor more compact than [`Rating Stars`](#/More%20components?id=ratingstars). The star,
 * unlike in [`Rating Stars`](#/More%20components?id=ratingstars),
 * remains filled regardless of score.
 *
 * @since 8.4.0
 */

var NumberRating = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
      rounding = _ref.rounding,
      fontType = _ref.fontType,
      rest = _objectWithoutProperties(_ref, _excluded);

  var roundedRating;
  /* istanbul ignore else */

  if (typeof rounding === 'number') {
    roundedRating = roundToDecimalPlace(value, rounding);
  } else if (typeof rounding === 'function') {
    roundedRating = rounding(value);
  }

  return /*#__PURE__*/React.createElement(StyledNumberRating, _extends({
    fontType: fontType
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Text, {
    fontType: fontType
  }, roundedRating), /*#__PURE__*/React.createElement(IconStar, null));
});
NumberRating.displayName = 'NumberRating';
NumberRating.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The rating value. */
  value: PropTypes.number.isRequired,

  /**
   * Rounds the value up or down to a desired threshold.
   * If a number is provided, the default function will round to that number
   * of decimal places.
   * Or, you can provide your own rounding function that takes `value` as an arg.
   */
  rounding: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),

  /**
   * Determines the font used for the label. It is encouraged to use a
   * header font type (ex: 'h4', 'bodyHeading', etc.).
   */
  fontType: PropTypes.oneOf(Object.keys(FONT_TYPES))
} : {};
NumberRating.defaultProps = {
  rounding: 1,
  fontType: FONT_TYPES.bodySmallHeading
};
/** @component */

export default NumberRating;